import Hand from './Hand';

export default Hand;
